/**
 * Initialize
 */
window.addEventListener('load', frd_add_to_cart_init);

function frd_add_to_cart_init() {
  const add_to_cart_buttons = document.querySelectorAll('button[name="frd-add-to-cart-button"]:not([aria-disabled="true"])');
  
  add_to_cart_buttons.forEach(frd_add_to_cart_button => {
    frd_add_to_cart_button.addEventListener('click', function() {
      frd_add_to_cart(frd_add_to_cart_button);
    });
  });
}

/**
 * Add to cart with Shopify Ajax API
 */
function frd_add_to_cart(add_to_cart_button) {
  const product_id = Number(add_to_cart_button.getAttribute('data-product-id'));
  const product_variant_id = Number(add_to_cart_button.getAttribute('data-product-variant-id'));
  const add_to_cart_data = {
  'items': [{
    'id': product_variant_id,
    'quantity': 1
    }]
  };
  const header_cart_bubble = document.querySelector('.cart-link__bubble');
  const success_element = document.createElement('p');

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(add_to_cart_data)
  })
  .then(response => {
    header_cart_bubble.classList.add('cart-link__bubble--visible');

    success_element.classList.add('frd-alert-success');
    success_element.innerHTML = 'Item has been added to your cart.';

    add_to_cart_button.before(success_element);

    $('body').trigger('added.ajaxProduct');

    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
